// imports shared across all home page templates
// imported from home page entry points

// global imports
require('../../assets/shared');
require('../../assets/shared_functions');
require('../../../../../core/js/plugins/mtc_slick');
require('../../site_scripts/mtc_vue_import');
require('../../site_scripts/mtc_lazy_load_images');
require('../../site_scripts/mtc_mobile_menu');
require('../../site_scripts/mtc_item_card_slider');

// home page imports
require('../../global/tabs');
require('../../global/read-more');
